import React, {Component} from 'react';

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import ReactDOM from 'react-dom';
import { DefaultRegionCode } from '../../localeAssets';
import { InputWithErrors, InputDate, InputPhoneNumber  } from '../../lib/forms';
import InputAddress from '../../lib/forms/InputAddress';
import { api } from '../../services/redux-beesConfig';
import isEmpty from 'lodash/isEmpty';
import AddressForm from '../Address/AddressForm';
import { AddressInfo } from '.';

class EditAddressView extends Component{
  constructor() {
    super();
    this.state = {
      addressForm: false,
    };
  }
  componentDidMount(){
    const element = ReactDOM.findDOMNode(this);
      if (element != null) {
        window.scrollTo(0, this.scrollPosition)
      }
  }
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }
  render() {
    const { addressForm } = this.state;
    const { translate, handleSubmit, cancel, user } = this.props;
    const addressFormToRep = addressForm ? <AddressForm className="collapse" /> : "";
        if (!isEmpty(user)){
          const address = AddressInfo(user)
        return (
        <div className="col-lg-12">
        <div className="card card-section" id="info">
        <div className="card-block">
          <div className="card-title">
            <h3>{translate("change-address-title")}</h3>
          </div>
                <form className="form-line edit" method="post" onKeyPress={this.handleKeyPress} onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 col-lg-4"></div>
                    <div className="col-12">
                      <div className="form-group">
                        <label>{translate("address")}</label>
                        <Field name="address" component={InputAddress}  type="text"  val={user.address} />
                      </div>
                      <div className="">
                        {addressFormToRep}
                        <small className="form-text text-muted">{translate("address-not-found-message")}
                          <span className="btn-action" data-toggle="collapse" data-target="#address" aria-expanded="true" aria-controls="address" onClick={() => {this.setState({addressForm:true})}} >{translate("right-here")}</span>.
                        </small>
                      </div>
                    </div>

                  </div>
                  <div className="row justify-content-end row-btn">
                    <div className="col-6 col-md-3">
                      <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel()} >{translate('cancel')}</button>
                    </div>
                    <div className="col-6 col-md-3">
                      <button className="btn btn-block btn-form btn-submit" type="submit" ui-sref="personal-information" >{translate('save')}</button>
                    </div>
                  </div>
                </form>
              </div>
              </div>
              </div>
      )
    }
      return(
        <div></div>
      )
  }
}

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};

EditAddressView = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(EditAddressView);

const EditAddressFormViewRedux = reduxForm({
  form: 'EditAddress',
  enableReinitialize: true,
})(EditAddressView)

class EditAddressFormHandler extends Component {

  handleSubmit(values) {
    const { currentLanguage, setFlashMessage, translate, history } = this.props;
    if (isEmpty(values)) {
      history.goBack();
      return ;
    }
    api.updateUser({ locale: currentLanguage, id: this.props.userID }, values)
    .then((res) => {
      setFlashMessage(`${translate('changes-saved-successfully')}`, true)
      history.goBack();
    })
    }
    cancel(values) {
      const { history } = this.props;
      history.goBack();
    }


  render() {

    return (
      <div>
        <EditAddressFormViewRedux  onSubmit={this.handleSubmit.bind(this)} cancel={this.cancel.bind(this)} user={this.props.user} />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
    userID: state.User.id,

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  }
}

EditAddressFormHandler = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAddressFormHandler);

EditAddressFormHandler = withRouter(EditAddressFormHandler);
export default EditAddressFormHandler;



// WEBPACK FOOTER //
// ./src/components/InfoPerson/EditAddress.js